import Header from "./components/Header/Header";
import Nav from "./components/Navbar/Navbar";
import Project from "./components/Projects/Project";
import Skill from "./components/Skills/Skill";
import Socmed from "./components/Socmed/Socmed";

function App() {
  return (
    <div className="bg-white">
      <div className="max-w-7xl flex flex-col justify-between mx-auto space-y-4 pb-16">
        <Nav />
        <div style={{ "height": "100vh" }}>
          <Header />
          <Socmed />
        </div>
        <Skill />
        <Project />
      </div>
      <footer className="text-center text-xs pb-4 text-gray-400">
        Made with ❤️ by Adam Ray
      </footer>
    </div>
  );
}

export default App;
